export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-gradient-to-br from-primary-500 to-accent-500">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-black text-background-50 mb-4">随时随地看漫画</h2>
            <p className="text-sm md:text-base text-background-50/90 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              酷看漫画移动端适配完美，手机、平板都能流畅阅读。横屏竖屏任意切换，离线下载功能让你随时随地畅享漫画世界。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#contact"
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-full bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-colors cursor-pointer no-underline"
              >
                <i className="ri-smartphone-line"></i>
                移动端入口
              </a>
              <a
                href="#features"
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-colors cursor-pointer no-underline"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>
          <div className="flex-1 w-full max-w-[400px]">
            <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '3/4' }}>
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20vibrant%20colorful%20manga%20reading%20app%20interface%20with%20comic%20pages%2C%20warm%20cozy%20ambient%20lighting%2C%20flat%20lay%20style%20on%20a%20clean%20desk%20with%20a%20coffee%20cup%2C%20modern%20lifestyle%20photography%2C%20soft%20shadows%2C%20editorial%20quality%2C%20warm%20orange%20and%20cream%20tones&width=600&height=800&seq=app-mobile-manga&orientation=portrait"
                alt="酷看漫画移动端阅读体验"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}